import photoSpain1 from '../../assets/photo-Spain-1.webp';
import photoSpain2 from '../../assets/photo-Spain-2.webp';
import photoPoland1 from '../../assets/photo-Poland-1.webp';
import photoPoland2 from '../../assets/photo-Poland-2.webp';
import photoMexico1 from '../../assets/photo-Mexico-1.webp';
import photoMexico2 from '../../assets/photo-Mexico-2.webp';
import photoItaly1 from '../../assets/photo-Italy-1.webp';
import photoItaly2 from '../../assets/photo-Italy-2.webp';
import photoFrance1 from '../../assets/photo-France-1.webp';
import photoFrance2 from '../../assets/photo-France-2.webp';
import photoAustria1 from '../../assets/photo-Austria-1.webp';
import photoAustria2 from '../../assets/photo-Austria-2.webp';
import photoUkraine1 from '../../assets/photo-Ukraine-1.webp';
import photoUkraine2 from '../../assets/photo-Ukraine-2.webp';
import photoSwiss1 from '../../assets/photo-Swiss-1.webp';
import photoSwiss2 from '../../assets/photo-Swiss-2.webp';



const placesData = [
    {
        id: 1,
        place: "France",
        photos: [photoFrance1, photoFrance2]
    },

    {
        id: 2,
        place: "Italy",
        photos: [photoItaly1, photoItaly2]
    },

    {
        id: 3,
        place: "Mexico",
        photos: [photoMexico1, photoMexico2]
    },

    {
        id: 4,
        place: "Spain",
        photos: [photoSpain1, photoSpain2]
    },

    {
        id: 5,
        place: "Ukraine",
        photos: [photoUkraine1, photoUkraine2]
    },

    {
        id: 6,
        place: "Austria",
        photos: [photoAustria1, photoAustria2]
    },

    {
        id: 7,
        place: "Poland",
        photos: [photoPoland1, photoPoland2]
    },

    {
        id: 8,
        place: "Switzerland",
        photos: [photoSwiss1, photoSwiss2]
    },
];

export default placesData;